import React from "react";
import { Droppable, Draggable } from "react-beautiful-dnd";
import { connect } from "react-redux";
import { emailHelper } from "../../helper/email.helper";
import { elementConstants } from "../../../../../constants/cms/form/element/element.constants";
import { DragContainer } from "../../../../components/UI/DragContainer/DragContainer";
import { DropArea } from "../../../../components/UI/DropArea/DropArea";
import { ElementOverlay, ElementOverlayEmail } from "../../../../components/element/Overlay/ElementOverlay";
import { progressiveEnhancementInnerContent } from "../../models/cerberus/progressiveEnhancement";
import { cssResetInnerContent } from "../../models/cerberus/cssReset";

import styled from "styled-components";
import { emailActions } from "../../../../../store/actions/cms/email/email.action";
import validateColor from "validate-color";

export const EmailDropArea = styled.table`
    background-color: ${(props) => (props.isDraggingOver ? "#00000005" : "inherit")}
    margin: auto;
`;
export const EmailDragContainer = styled.tr`
  background-color: ${(props) => (props.isDragging ? "#e7f9ff" : props.backgroundColor)};
`;

export const EmailDropAreaContainer = styled.tr`
background-color: ${(props) => (props.isDraggingOver ? "#28a74563" : "inherit")}
border: ${(props) => (props.isDraggingOver ? "1px dashed #28a745" : "inherit")}
`;

class EmailContent extends React.Component {
  componentDidMount() {
    document.addEventListener("click", this.handleClick, false);
  }
  componentWillUnmount() {
    document.removeEventListener("click", this.handleClick, false);
  }
  handleClick = (e) => {
    if (this.elementContainerRef.contains(e.target) || (this.props.asideEditorRef && this.props.asideEditorRef.contains(e.target))) {
      return;
    } else if (this.props.cms.deselectionBlocked) {
      return;
    } else {
      this.onDeselect();
    }
  };
  onDeselect = () => {
    const { dispatch } = this.props;
    dispatch(emailActions.deselect());
  };
  onSelect = (element) => {
    const { dispatch } = this.props;
    dispatch(emailActions.select(element));
  };
  onDelete = (element) => {
    const { dispatch } = this.props;
    dispatch(emailActions.remove(element));
  };
  selectedBorderStyle = (el) => {
    if (el.type === elementConstants.CONTAINER) return "1px solid #28a74563";
    else return "1px solid #5593dc94";
  };
  render() {
    const { elements, selectedElement } = this.props.email;
    const { template } = this.props;
    const sortedElements = emailHelper.sortElements(elements, null, true);
    return (
      <div>
        <style>{cssResetInnerContent}</style>
        <style>{progressiveEnhancementInnerContent}</style>
        <div
          width="100%"
          style={{
            margin: 0,
            padding: "0px !important",
            backgroundColor: template ? (validateColor(template.content.main.background) ? template.content.main.background : template.content.main.backgroundColor) : "#fff",
          }}
        >
          <center
            style={{ width: "100%", backgroundColor: template ? (validateColor(template.content.main.background) ? template.content.main.background : template.content.main.backgroundColor) : "#fff" }}
          >
            <table
              role="presentation"
              border="0"
              cellPadding="0"
              cellSpacing="0"
              width="100%"
              style={{ backgroundColor: template ? (validateColor(template.content.main.background) ? template.content.main.background : template.content.main.backgroundColor) : "#fff" }}
            >
              <tbody>
                <tr>
                  <td>
                    {/*    <div style="display: none; font-size: 1px; line-height: 1px; max-height: 0px; max-width: 0px; opacity: 0; overflow: hidden; mso-hide: all; font-family: sans-serif;">
                                        &zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;
                                    </div> */}
                    <div
                      /* ref={r => (this.elementContainerRef = r)} */ align="center"
                      role="presentation"
                      style={{ margin: "0px auto", maxWidth: "680px" /*  backgroundColor: template ? template.content.content.backgroundColor : '#fff' */ }}
                      className="email-container"
                    >
                      <table ref={(r) => (this.elementContainerRef = r)} align="center" role="presentation" cellSpacing="0" cellPadding="0" border="0" width="680" style={{ position: "relative" }}>
                        <tbody>
                          <tr>
                            <td>
                              <Droppable droppableId="content">
                                {(provided, snapshot) => {
                                  return (
                                    <EmailDropArea
                                      align="center"
                                      role="presentation"
                                      cellSpacing="0"
                                      cellPadding="0"
                                      border="0"
                                      width="100%"
                                      ref={provided.innerRef}
                                      {...provided.droppableProps}
                                      isDraggingOver={snapshot.isDraggingOver}
                                    >
                                      <tbody>
                                        {sortedElements.map((el, index) => {
                                          return (
                                            <Draggable key={index} draggableId={el.id} index={index}>
                                              {(provided, snapshot) => (
                                                <EmailDragContainer
                                                  {...provided.draggableProps}
                                                  {...this.props}
                                                  ref={provided.innerRef}
                                                  isDragging={snapshot.isDragging}
                                                  hasChildren={elements.length > 0}
                                                >
                                                  <td style={{ position: "relative" }}>
                                                    <table
                                                      style={{
                                                        width: "100%",
                                                        padding: selectedElement && el.id === selectedElement.id ? "0px" : `1px`,
                                                        border: selectedElement && el.id === selectedElement.id ? "1px solid #5593dc94" : `0px`,
                                                      }}
                                                    >
                                                      <tbody>
                                                        <tr onClick={() => this.onSelect(el)}>
                                                          <td>
                                                            <table>
                                                              <tbody>{emailHelper.renderElement(el)}</tbody>
                                                            </table>
                                                          </td>
                                                        </tr>
                                                      </tbody>
                                                      {selectedElement && el.id === selectedElement.id ? (
                                                        <tbody>
                                                          <tr>
                                                            <td>
                                                              <ElementOverlayEmail
                                                                targetElement={el}
                                                                dragHandleProps={provided.dragHandleProps}
                                                                selectedElement={selectedElement}
                                                                onDelete={this.onDelete}
                                                              />
                                                            </td>
                                                          </tr>
                                                        </tbody>
                                                      ) : null}
                                                    </table>
                                                  </td>

                                                  <td {...provided.dragHandleProps} style={{ display: "none" }} />
                                                </EmailDragContainer>
                                              )}
                                            </Draggable>
                                          );
                                        })}
                                        {elements.length < 1 ? (
                                          <tr
                                            style={{
                                              height: "200px",
                                              border: "2px dotted #0000000f",
                                            }}
                                          >
                                            <td>{provided.placeholder}</td>
                                          </tr>
                                        ) : (
                                          <tr>
                                            <td>{provided.placeholder}</td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </EmailDropArea>
                                  );
                                }}
                              </Droppable>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </center>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    cms: state.cms,
    email: state.email,
    selectedElement: state.email.selectedElement,
    template: state.template.template,
  };
}
export default connect(mapStateToProps)(EmailContent);
